import type { TMessages } from '@/types/TMessages'

export const messages = {
  requestPrice: 'Все цены',
  leasingAvailable: 'Доступно в лизинг',
  buy: 'Купить',
} satisfies TMessages
